export async function createLegalEntity(legalEntityRepository, legalEntity) {
  return legalEntityRepository.save(legalEntity);
};
